
let fallbackDelay = 1000 / 60

function fallback (callback) {
    window.setTimeout(callback, fallbackDelay)
}

export default window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    fallback

